import React from "react";

import BackdropSection from "../../Backdrop/BackdropSection/BackdropSection";
import UILoader from "../Loader";

const UISoleraLoader = props => {
  const loader = props.loader ? <UILoader /> : null;
  return <BackdropSection>{loader}</BackdropSection>;
};

export default UISoleraLoader;
